<template>
    <div class="icons-btn">
        <div class="icons-btn-single">
            <el-tooltip effect="light" content="放大" placement="top">
                <div class="icons icons-fir" @mouseover="changeFirstUrl(true)" @mouseleave="changeFirstUrl(false)"
                    @click="handleAmplify">
                    <img :src="iconFirstUrl" alt="" />
                </div>
            </el-tooltip>
            <el-tooltip effect="light" content="卡片信息" placement="top">
                <div class="icons icons-sec" @mouseover="changeSecondUrl(true)" @mouseleave="changeSecondUrl(false)"
                    @click="handleShowInfo(false)">
                    <img :src="iconSecondUrl" alt="" />
                </div>
            </el-tooltip>
            <el-tooltip effect="light" content="下载" placement="top">
                <div class="icons icons-thr" @mouseover="changeThirdUrl(true)" @mouseleave="changeThirdUrl(false)"
                    @click="handleDownload(false)">
                    <img :src="iconThirdUrl" alt="" />
                </div>
            </el-tooltip>
        </div>
        <!-- 文字描述说明 -->
        <el-dialog :title="infoTitle" :visible.sync="chartDialogVisble" :width="widthShow"
            :before-close="handleAmplifyClose" :modal-append-to-body="false" :modal="true">
            <div class="icon-dialog-block">
                <iconsblock @handleShowInfo="handleShowInfo" @handleDownload="handleDownload" />
            </div>
            <el-select v-model="countryValue" class="select-index" placeholder="请选择" @change="handleRegiond"
                v-if="showData" style="margin-left:30px" v-show="regionShow">
                <el-option v-for="item in wholeCountry" :key="item.value" :label="item.label"
                    :value="{ value: item.value, label: item.label }">
                </el-option>
            </el-select>
            <el-select v-model="companyValue" class="select-index" placeholder="请选择" @change="dataChange"
                v-if="showData" v-show="companyShow">
                <el-option v-for="item in companies" :key="item.value" :label="item.label"
                    :value="{ value: item.value, label: item.label }">
                </el-option>
            </el-select>
            <el-date-picker style="margin:15px 0 0 30px" class="dataTime" v-model="value2" type="monthrange"
                @change="dataChange" align="right" unlink-panels range-separator="至" start-placeholder="开始月份"
                end-placeholder="结束月份" value-format="yyyy-MM" :picker-options="pickerOptions" v-if="showData" >
            </el-date-picker>
            <div :class="['width-height', { site: siteShow }]">
                <div class="NoCont" v-if="noContShow">请选择需要查询的时间</div>
                <!-- <div v-if="noContShow"> -->

                    <div ref="chartBox" :style="{ width: '100%', height: '100%' }" ></div>
                <!-- </div> -->
            </div>
            <div class="legendData" v-if="idNameShow">
                <span> <i class="legendOne"></i> v0</span>
                <span> <i class="legendTwo"></i> v1-v2</span>
                <span> <i class="legendThree"></i> v3-v4</span>
                <span> <i class="legendFour"></i> v5</span>
            </div>
        </el-dialog>
        <el-dialog :title="infoTitle" :visible.sync="infoDialogVisible" :width="widthShow"
            :before-close="handleInfoClose" :modal-append-to-body="false" :modal="true">
            <div class="dialog-text-block">
                <p v-for="(text, index) in details" :key="index">{{ text }}</p>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import iconsblock from "./iconsblock.vue";
import {
    GetRegionComboBox,
    GetCompaniesData,
} from "@/api/api";
export default {
    components: {
        iconsblock,
    },
    props: {
        details: {
            default: [],
        },
        infoTitle: {
            default: "--",
        },
        idName: {
            default: "--",
        },
        stringPaintChart: {
            default: "--",
        },
        allOneValue: String,
        timeArray: Array
    },
    data() {
        return {
            timerData:this.timeArray,
            iconFir: false,
            iconSec: false,
            iconThr: false,
            chartDialogVisble: false,
            infoDialogVisible: false,
            idNameShow: false,
            pickerOptions: {
                shortcuts: [{
                    text: '本月',
                    onClick(picker) {
                        picker.$emit('pick', [new Date(), new Date()]);
                    }
                }, {
                    text: '今年至今',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date(new Date().getFullYear(), 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近六个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setMonth(start.getMonth() - 6);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: "本季度",
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setMonth(start.getMonth() - 2);
                        picker.$emit("pick", [start, end]);
                    },
                },
                ]
            },
            value2: [],
            wholeCountry: [],
            companyId: 0,
            companyValue: this.allOneValue,
            companies: [],
            showData: true,
            companyShow:true,
            noContShow:true,
            showNum:0,
            regionShow:true
        };
    },
    computed: {
        iconFirstUrl() {
            return this.iconFir
                ? require("../../../assets/img/icons/lightenlarge.svg")
                : require("../../../assets/img/icons/enlarge.svg");
        },
        iconSecondUrl() {
            return this.iconSec
                ? require("../../../assets/img/icons/lightabout.svg")
                : require("../../../assets/img/icons/about.svg");
        },
        iconThirdUrl() {
            return this.iconThr
                ? require("../../../assets/img/icons/lightdownload.svg")
                : require("../../../assets/img/icons/download.svg");
        },
        widthShow() {
            return document.body.offsetWidth > 1300 ? "70%" : "70%";
        },
        siteShow() {
            return this.$route.name === "Index";
        },
    },
    methods: {
        handleRegiond(v) {
            if (v.label === this.countryValue) return;
            this.countryId = v.value;
            this.companies = [];
            this.companyValue = "";
            //   this.companyId = 0;
            this.GetCompaniesData();
        },
        dataChange() {
            this.noContShow=false
            console.log('[ this.allOneValue ] >', this.allOneValue,this.countryValue)
            this.countryValue=this.allOneValue
            this.$emit("chooseData", this.idName, this.value2, this.countryValue, this.companyValue,this.showNum,)
            
        },
        // 获取全国大区
        comboBoxData() {
            GetRegionComboBox({ ticket: this.urlData }).then((res) => {
                if (res) {
                    this.countryValue = res.Data[0].RegionName;
                }
                this.countryId = res.Data[0].Id;

                if (res.Data.legend >= 0) {
                    this.checkId = res.Data[0].Id;
                }
                res.Data.forEach((e) => {
                    const item = {
                        value: e.Id,
                        label: e.RegionName,
                    };
                    this.wholeCountry.push(item);
                });

                this.GetCompaniesData();
            });
        },
        //获取公司
        GetCompaniesData() {
            let param = {
                regionId: this.countryId,
                ticket: this.urlData,
            };
            GetCompaniesData(param).then((res) => {
                this.companyValue = res[0].Text;
                this.companyId = res[0].CompanyId;
                res.forEach((e) => {
                    const item = {
                        value: e.CompanyId,
                        label: e.Text,
                    };
                    this.companies.push(item);
                });
            });
        },
        
        changeFirstUrl(show) {
            this.iconFir = show;
        },
        changeSecondUrl(show) {
            this.iconSec = show;
        },
        changeThirdUrl(show) {
            this.iconThr = show;
        },
        handleAmplify() {
            console.log("[  this.idName ] >", this.idName,11);

            if (this.idName == "middleFour") {
                this.idNameShow = true;
            } else {
                this.idNameShow = false;
            }

            if (this.idName == "bottomOne" || this.idName == "middleOne") {
                this.showData = false
                this.noContShow=false
            }

            if (this.idName == "myChartB" || this.idName == "myChartBB"|| this.idName == "myChart3"|| this.idName == "myChart4"|| this.idName == "myChart5"|| this.idName == "myChart6"|| this.idName == "myChart7"|| this.idName == "myChart8") {
                this.companyShow = false
                this.noContShow=false
                this.regionShow=false
            }

            if (this.idName == "myChartC" || this.idName == "myChart22"|| this.idName == "myChart33"|| this.idName == "myChart44"|| this.idName == "myChart55"|| this.idName == "myChart66"|| this.idName == "myChart77") {
                this.companyShow = false
                this.noContShow=false
                this.regionShow=false
            }
            this.chartDialogVisble = true;
            this.$emit("changeTextColor", true);
            this.$nextTick(() => {
                this.$refs.chartBox.setAttribute("id", this.idName);
                this.stringPaintChart();
            });
            this.comboBoxData()
        },
        
        handleAmplifyClose() {
            this.chartDialogVisble = false;
            this.$emit("changeTextColor", false);
            if (this.$refs.chartBox.removeAttribute("id"));
        },
        handleShowInfo(isShow) {
            this.infoDialogVisible = true;
            setTimeout(() => {
                if (isShow) {
                    this.handleAmplifyClose();
                }
            }, 0);
        },
        handleInfoClose() {
            this.infoDialogVisible = false;
        },
        handleDownload(isShow) {
            if (isShow) {
                this.$refs.chartBox.removeAttribute("id", this.idName);
            }
            setTimeout(() => {
                if (!this.idName)
                    return this.$message({
                        showClose: true,
                        message: "下载失败，请稍后重试",
                        type: "error",
                    });
                this.$emit("download", this.idName, this.infoTitle);
            }, 0);
        },
    },
};
</script>

<style scoped>
.icons-btn-single {
    display: flex;
    justify-content: space-between;
    box-shadow: 0px 0px 6px 0px #7580be;
    border-radius: 4px;
    border: 1px solid #1582a3;
    cursor: pointer;
    align-items: center;
}

.icons {
    padding: 8px 6px 6px 6px;
}

.icons-fir {
    margin-left: 6px;
}

.icons-btn>>>.el-dialog__body {
    height: 87%;
    width: 100%;
    padding: 0;
}

.icons-btn>>>.el-dialog {
    overflow: hidden;
    height: 80%;
    margin-top: 5vh !important;
}

.width-height {
    width: 100%;
    height: 95%;
    margin: 0;
}

.icon-dialog-block {
    position: absolute;
    top: 10px;
    right: 58px;
}

>>>.el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.09) !important;
}

.dialog-text-block {
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
    font-size: 15px;
    padding: 16px 25px;
}

.dialog-text-block p {
    line-height: 20px;
    margin-bottom: 6px;
}

.site {
    position: relative;
    top: 0;
}

.legendData {
    height: 5%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    width: 70%;
    bottom: 16%;
    color: #000;
}

.legendData span {
    margin: 0 5px;
    font-size: 12px;
    list-style: none;
    font-family: initial;
}

.legendData span i {
    display: inline-block;
    width: 10px;
    height: 5px;
}

.legendData span .legendOne {
    background: #8993ff;
}

.legendData span .legendTwo {
    background: #1ffd8a;
}

.legendData span .legendThree {
    background: #f8d135;
}

.legendData span .legendFour {
    background: #00f2dd;
}

@media (max-width: 1465px) {
    .icons {
        padding: 3px 6px 3px 6px !important;
    }

    .icons-btn-single {
        height: 30px;
    }

    .legendData {
        height: 10%;
        bottom: 100px;
    }
    .icons-btn>>>.el-dialog {
    overflow: hidden;
    width:60% !important;
    height: 70%;
    margin-top: 5vh !important;
}
.width-height{
    height: 88%;
}
}

>>>.el-select-dropdown {
    background: none !important;
}
.NoCont{
    width: 100%;
    text-align: center;
    line-height: 300px;
    font-size: 24px;
}
>>> .dataTime .el-range-input{
    color:#333 !important
}
>>>.dataTime .el-range-separator{
    color: #333 !important;
}
</style>
<style>
/* .el-picker-panel__body{
    background: #fff !important;
} */
.el-date-range-picker.has-sidebar {
    left: 15% !important;
}

.select-index .el-input .el-input__inner {
    color: #333
}
@media (max-width: 1300px) {

    .el-date-editor--monthrange.el-input, .el-date-editor--monthrange.el-input__inner{
        width: 240px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/dataChart/iconsBlock/index.vue